import type { AlertActionProps, AlertProps } from './alert'
import { AlertActionButton } from './alert-action-button'
import { AlertCloseButton } from './alert-close-button'

type AlertActionsProps = {
  actions?: AlertActionProps[]
  onClose?: AlertProps['onClose']
  closeButtonProps?: AlertProps['closeButtonProps']
  className?: string
  isSmScreen: boolean
}

export const AlertActions = ({
  actions = [],
  onClose,
  closeButtonProps,
  className,
  isSmScreen,
}: AlertActionsProps) => {
  return (
    <div className={className}>
      {actions.map(({ children, ...action }, index, arr) => (
        <AlertActionButton
          // eslint-disable-next-line @eslint-react/no-array-index-key -- alert actions are a fixed per-render set; stateless buttons, never reordered
          key={index}
          isSmScreen={isSmScreen}
          style={{
            order: isSmScreen ? arr.length - index : index,
          }}
          {...action}
        >
          {children}
        </AlertActionButton>
      ))}
      {onClose && (
        <AlertCloseButton
          {...closeButtonProps}
          isSmScreen={isSmScreen}
          onClick={onClose}
        />
      )}
    </div>
  )
}
